// App.js
import React, { Fragment, useState, useEffect } from "react";
import "./App.css";
import $ from "jquery";
import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import {
  ErrorBoundary,
  SearchProvider,
  Results,
  Paging,
  PagingInfo,
  WithSearch,
} from "@elastic/react-search-ui";
import { Layout } from "@elastic/react-search-ui-views";
import "@elastic/react-search-ui-views/lib/styles/styles.css";

import ResultView from "./ResultView"; 

// App Search connector
const connector = new AppSearchAPIConnector({
  searchKey: $('meta[name="elasticPublicKey"]').attr("content")
    || "search-t72uzb4fexzo1x73hphs3wz1",
  engineName: $('meta[name="elasticCardEngine"]').attr("content")
    || "mizrahisearch-card",
  endpointBase: $('meta[name="elasticBaseUrl"]').attr("content")
    || "https://mizrahisearchapp.ent.eu-central-1.aws.cloud.es.io"
});

export default function App() {
  const callKey = $('meta[name="searchuikey"]').attr("content");
  const [currResults, setCurrResults] = useState(null);
  const [siteFillter, setSiteFillter] = useState("");
  const [siteEngineKey] = useState(callKey);
  const siteDomainMeta = $('meta[name="siteDomain"]').attr("content");
  const [siteDomain] = useState(siteDomainMeta);

  const onUpdate = (results) => {
    if (!currResults) setCurrResults(results);
  };

  useEffect(() => {
    const v = $('meta[name="siteDomain"]').attr("content");
    setSiteFillter(v || "");
  }, [currResults]);

  const searchFilters = [];
  if (siteDomain) {
    searchFilters.push({ field: "url_host", values: [siteDomain] });
  }

    return (
      <SearchProvider
        config={{
          apiConnector: connector,
          initialState: { resultsPerPage: 10 },
          searchQuery: {

            search_fields: {
              title: {},
              body_content: {}
            },

            result_fields: {
              title:            { raw: {}, snippet: { size: 100, fallback: true } },
              meta_description: { snippet: { size: 160, fallback: true } },
              url:              { raw: {} },
              url_host:         { raw: {} },
              image:            { raw: {} },
              image_urls:       { raw: {} }
            },
            filters: searchFilters.length > 0 ? searchFilters : undefined
          }
        }}
      >

      <WithSearch
        mapContextToProps={({ wasSearched, results }) => {
          onUpdate(results);
          return { wasSearched };
        }}
      >
        {({ wasSearched }) => (
          <div className="App">
            <ErrorBoundary>
              <Layout
                bodyContent={
                  <Results
                    titleField="title"
                    urlField="url"
                    resultView={ResultView}
                  />
                }
                bodyHeader={
                  wasSearched && (
                    <PagingInfo
                      view={({ totalResults }) => (
                        <div className="paging-info">
                          {totalResults ? <Fragment /> : <div className="noTotalResults" />}
                        </div>
                      )}
                    />
                  )
                }
                bodyFooter={<Paging resultsPerPage={10} />}
              />
            </ErrorBoundary>
          </div>
        )}
      </WithSearch>
    </SearchProvider>
  );
}
